import type { FigmaIconProps } from './types';

export const IconFigmaWarningTriangle = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2.33333L14.3333 13.3333H1.66667L8 2.33333Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path d="M8 6.66667V9.33333" stroke={color} strokeWidth="1.33333" strokeLinecap="round" />
    <path
      d="M7.99961 11.0663C8.14676 11.0663 8.266 11.1858 8.26621 11.3329C8.26621 11.4802 8.14689 11.5995 7.99961 11.5995C7.85251 11.5993 7.73301 11.4801 7.73301 11.3329C7.73322 11.186 7.85264 11.0666 7.99961 11.0663Z"
      fill={color}
      stroke={color}
      strokeWidth="0.666667"
    />
  </svg>
);
